import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function  Mumbaitobhimashankarcab() {



  const cardData = {
    keyword: " Mumbai to Bhimashankar Cab",

"headingDescription": "Royal Route Cab offers reliable and comfortable Mumbai to Bhimashankar cab services, ensuring a safe, smooth, and convenient journey for devotees, nature lovers, and weekend travelers. Whether you are planning a spiritual visit to Bhimashankar Jyotirlinga, a trekking trip, or a peaceful getaway in the Sahyadri hills, our professional drivers and well-maintained vehicles provide a stress-free travel experience. The Mumbai to Bhimashankar route covers approximately 210 to 230 km and takes around 5 to 6 hours depending on traffic and road conditions. We offer flexible booking options including one-way trips, round trips, and customized travel plans with transparent pricing and no hidden charges. Our fleet includes air-conditioned sedans, spacious SUVs, luxury cars, and Tempo Travellers suitable for all types of travelers. With easy online booking and 24/7 customer support, Royal Route Cab is your trusted partner for Mumbai to Bhimashankar travel.",

"topPlaces": [
  {
    "title": "Bhimashankar Jyotirlinga Temple",
    "description": "Bhimashankar Jyotirlinga is one of the twelve sacred Jyotirlingas of Lord Shiva, located deep in the Sahyadri hills. Surrounded by dense forests and misty mountains, it is a highly spiritual destination attracting devotees throughout the year. The temple architecture reflects ancient Hemadpanthi style and offers a peaceful divine atmosphere perfect for prayer and meditation."
  },
  {
    "title": "Bhimashankar Wildlife Sanctuary",
    "description": "Bhimashankar Wildlife Sanctuary is a rich biodiversity hotspot known for its dense evergreen forests, rare flora and fauna, and scenic trekking trails. It is home to the endangered Indian Giant Squirrel (Shekru), making it a paradise for wildlife photographers and nature enthusiasts."
  },
  {
    "title": "Hanuman Lake",
    "description": "Hanuman Lake is a serene natural water body located near Bhimashankar temple. Surrounded by thick greenery, it offers a calm and peaceful environment ideal for relaxation, birdwatching, and short nature walks after temple darshan."
  },
  {
    "title": "Nagphani Point (Cobra Viewpoint)",
    "description": "Nagphani Point, also known as Cobra Viewpoint, is a scenic cliff point offering breathtaking panoramic views of the Sahyadri mountains. It is a popular trekking stop where travelers can enjoy misty valleys, cool winds, and stunning sunrise or sunset views."
  },
  {
    "title": "Gupt Bhimashankar",
    "description": "Gupt Bhimashankar is a hidden and lesser-known spiritual site believed to be the original source of the Bhima River. It is surrounded by dense forest trails and offers a peaceful, offbeat experience for spiritual seekers and adventure lovers."
  },
  {
    "title": "Shidi Ghat Trek Route",
    "description": "The Shidi Ghat Trek Route is one of the most adventurous paths leading to Bhimashankar, featuring steep climbs, rocky steps, and forest trails. It is popular among trekking enthusiasts looking for a challenging yet rewarding journey through nature."
  },
  {
    "title": "Origin of Bhima River",
    "description": "The origin point of the Bhima River near Bhimashankar is a sacred natural spot surrounded by forested landscapes. It holds religious significance and is often visited by pilgrims as part of their spiritual journey."
  },
  {
    "title": "Mokshakund Tirtha",
    "description": "Mokshakund Tirtha is a holy water tank near the Bhimashankar temple believed to have spiritual cleansing powers. Devotees often take a ritual bath here before visiting the main Jyotirlinga temple."
  },
  {
    "title": "Bombay Point Bhimashankar View",
    "description": "Bombay Point near Bhimashankar offers spectacular valley views and mist-covered mountains, especially during monsoon season. It is a peaceful stop for photography and enjoying the natural beauty of the Western Ghats."
  },
  {
    "title": "Khandas Village",
    "description": "Khandas Village is the base point for the Bhimashankar trek and offers beautiful rural landscapes, local culture, and traditional Maharashtrian hospitality. It is also a starting point for trekking routes through lush green forests."
  }
],







services: [
  {
    name: "Mumbai to Bhimashankar Cab",
    description: "Mumbai to Bhimashankar cab service offers a comfortable and spiritual journey to one of the 12 Jyotirlinga temples in India. The route passes through scenic hills, forests, and ghats, making the trip peaceful and refreshing. Ideal for pilgrims, families, and group travelers, this service ensures safe and timely travel. Professional drivers experienced in ghat roads enhance safety. Customers can choose from sedan, SUV, and luxury vehicles. It guarantees a smooth and devotional travel experience."
  },
  {
    name: "Mumbai to Bhimashankar Taxi",
    description: "Mumbai to Bhimashankar taxi provides reliable and convenient transportation for devotees visiting the holy temple. With door-to-door pickup and drop, this service ensures comfort and ease. Vehicles are well-maintained and driven by experienced chauffeurs. Suitable for family trips and religious journeys. Flexible travel timings add convenience. It ensures a safe and stress-free journey."
  },
  {
    name: "Mumbai to Bhimashankar Cab Service",
    description: "Mumbai to Bhimashankar cab service is designed for long-distance travel with a focus on safety and comfort. This service is ideal for pilgrims and tourists exploring nearby nature and temples. Vehicles are maintained for smooth highway and ghat performance. Professional drivers ensure a comfortable ride. Flexible pickup options across Mumbai enhance convenience. It ensures a reliable journey."
  },
  {
    name: "Mumbai to Bhimashankar Taxi Service",
    description: "Mumbai to Bhimashankar taxi service offers dependable intercity travel for religious and leisure trips. This service is suitable for families, groups, and senior citizens. Clean vehicles and experienced drivers ensure a smooth journey. Flexible scheduling allows easy planning. It guarantees a peaceful and comfortable travel experience."
  },
  {
    name: "Cab from Mumbai to Bhimashankar",
    description: "Cab from Mumbai to Bhimashankar provides a private and personalized travel experience for long-distance journeys. Travelers can enjoy flexible stops along the scenic route. This service is ideal for families and groups. Professional drivers ensure safe travel in hilly areas. It offers a relaxed and enjoyable journey."
  },
  {
    name: "Taxi from Mumbai to Bhimashankar",
    description: "Taxi from Mumbai to Bhimashankar offers a convenient way to reach the temple with comfort and reliability. With experienced drivers and clean vehicles, this service ensures safe travel through ghat roads. Door-to-door pickup adds convenience. Suitable for religious visits and short trips. It ensures a smooth journey."
  },
  {
    name: "Mumbai to Bhimashankar Cab Booking",
    description: "Mumbai to Bhimashankar cab booking allows travelers to reserve their ride easily with flexible options. Customers can choose vehicle type, pickup location, and travel time. Instant confirmation and transparent pricing ensure a hassle-free experience. It simplifies travel planning."
  },
  {
    name: "Mumbai to Bhimashankar Taxi Booking Online",
    description: "Mumbai to Bhimashankar taxi booking online provides a quick and easy way to book your journey from anywhere. Customers can compare vehicle options and pricing easily. Secure payment and instant confirmation ensure reliability. It ensures availability during peak pilgrimage seasons."
  },
  {
    name: "Mumbai to Bhimashankar Cab Price",
    description: "Mumbai to Bhimashankar cab price varies based on vehicle type, trip type, and travel timing. Transparent pricing ensures no hidden charges. Budget-friendly and premium options are available. It helps travelers choose the best option. It ensures value-driven travel."
  },
  {
    name: "Mumbai to Bhimashankar Taxi Fare",
    description: "Mumbai to Bhimashankar taxi fare is designed to be affordable and competitive for all travelers. Fare depends on car type and travel plan. Customers receive clear pricing details before booking. Multiple options suit different budgets. It ensures cost-effective travel."
  },
  {
    name: "Mumbai to Bhimashankar One Way Cab",
    description: "Mumbai to Bhimashankar one way cab is a cost-effective option for travelers needing a single-side drop. This service eliminates return charges and offers flexible travel timings. Ideal for pilgrims and short trips. Comfortable vehicles ensure a smooth ride. It is perfect for budget travel."
  },
  {
    name: "Mumbai to Bhimashankar Round Trip Taxi",
    description: "Mumbai to Bhimashankar round trip taxi is ideal for travelers planning a return journey after darshan. This package includes pickup, drop, waiting time, and return travel. Flexible schedules make it convenient. Suitable for family trips and group travel. It ensures comfort and efficiency."
  },
  {
    name: "Mumbai to Bhimashankar Innova Cab",
    description: "Mumbai to Bhimashankar Innova cab is perfect for families and groups seeking spacious and comfortable travel. The vehicle offers ample seating and luggage space. Ideal for long-distance temple visits. Professional drivers ensure safety. It provides a premium travel experience."
  },
  {
    name: "Mumbai to Bhimashankar Ertiga Cab",
    description: "Mumbai to Bhimashankar Ertiga cab is suitable for small groups and families looking for an affordable ride. This vehicle offers comfortable seating and good mileage. It is ideal for budget-friendly travel. Drivers ensure smooth journeys. It ensures a pleasant experience."
  },
  {
    name: "Mumbai to Bhimashankar Sedan Cab",
    description: "Mumbai to Bhimashankar sedan cab is ideal for couples and small families seeking economical travel. Sedans offer smooth driving and comfort for medium-distance trips. This option is widely preferred for its affordability. Professional drivers ensure safe travel. It is perfect for a relaxed journey."
  },
  {
    name: "Mumbai to Bhimashankar SUV Taxi",
    description: "Mumbai to Bhimashankar SUV taxi provides extra space and better performance on hilly roads. SUVs offer stability and comfort for ghat travel. This option is ideal for families and groups. Drivers ensure safe and reliable travel. It delivers a comfortable experience."
  },
  {
    name: "Cheap Mumbai to Bhimashankar Cab",
    description: "Cheap Mumbai to Bhimashankar cab offers budget-friendly travel options without compromising safety and comfort. This service is ideal for cost-conscious travelers. Economical sedan options help reduce travel costs. Transparent pricing ensures no hidden charges. It is perfect for affordable trips."
  },
  {
    name: "Best Mumbai to Bhimashankar Taxi Service",
    description: "Best Mumbai to Bhimashankar taxi service ensures a premium travel experience with top-quality vehicles and professional drivers. This service focuses on safety, punctuality, and customer satisfaction. Customers can choose from multiple vehicle options. Transparent pricing builds trust. It guarantees a reliable and comfortable journey."
  }
],

tableData: [
  ["Mumbai to Bhimashankar Cab", "Mumbai to Bhimashankar Taxi"],
  ["Mumbai to Bhimashankar Cab Service", "Mumbai to Bhimashankar Taxi Service"],
  ["Cab from Mumbai to Bhimashankar", "Taxi from Mumbai to Bhimashankar"],
  ["Mumbai to Bhimashankar Cab Booking", "Mumbai to Bhimashankar Taxi Booking Online"],
  ["Mumbai to Bhimashankar Cab Price", "Mumbai to Bhimashankar Taxi Fare"],
  ["Mumbai to Bhimashankar One Way Cab", "Mumbai to Bhimashankar Round Trip Taxi"],
  ["Mumbai to Bhimashankar Innova Cab", "Mumbai to Bhimashankar Ertiga Cab"],
  ["Mumbai to Bhimashankar Sedan Cab", "Mumbai to Bhimashankar SUV Taxi"],
  ["Cheap Mumbai to Bhimashankar Cab", "Best Mumbai to Bhimashankar Taxi Service"]
],


whychoose: [
  {
    WhyChooseheading: "Comfortable Mumbai to Bhimashankar Travel",
    WhyChoosedescription: "Royal Route Cabs offers a smooth and comfortable Mumbai to Bhimashankar cab service, ideal for devotees, nature lovers, and weekend spiritual trips."
  },
  {
    WhyChooseheading: "Experienced Ghat Route Drivers",
    WhyChoosedescription: "Our drivers are skilled in handling hilly and ghat sections on the Bhimashankar route, ensuring safe and secure travel."
  },
  {
    WhyChooseheading: "Transparent Pricing with No Hidden Charges",
    WhyChoosedescription: "Royal Route Cabs provides clear and upfront pricing including tolls, driver allowance, and all charges with no hidden costs."
  },
  {
    WhyChooseheading: "24/7 Cab Service Availability",
    WhyChoosedescription: "Our Mumbai to Bhimashankar cab service operates 24/7, allowing flexible travel for early morning darshan or overnight journeys."
  },
  {
    WhyChooseheading: "Clean & Comfortable AC Vehicles",
    WhyChoosedescription: "All vehicles are fully air-conditioned, well-maintained, and regularly cleaned to ensure a comfortable travel experience."
  },
  {
    WhyChooseheading: "One Way & Round Trip Options",
    WhyChoosedescription: "Choose from one-way cab service, round-trip bookings, or same-day return packages for Bhimashankar darshan."
  },
  {
    WhyChooseheading: "Multiple Vehicle Options",
    WhyChoosedescription: "We offer sedan cars, SUVs like Ertiga and Innova, premium Innova Crysta, and Tempo Travellers for families and group travel."
  },
  {
    WhyChooseheading: "Trusted Pilgrimage Cab Service",
    WhyChoosedescription: "Royal Route Cabs is trusted by travelers for Mumbai to Bhimashankar cab bookings due to punctual service and reliable drivers."
  }
]

};

const faqData = [
  { question: "Do you provide Mumbai to Bhimashankar cab service?", answer: "Yes, Royal Route Cabs offers reliable cab services from Mumbai to Bhimashankar for both one-way and round trips." },
  { question: "What is the distance between Mumbai and Bhimashankar?", answer: "The distance is approximately 210 to 230 km and takes around 5 to 6 hours depending on route and traffic." },
  { question: "Is cab service available 24 hours?", answer: "Yes, our Mumbai to Bhimashankar cab service operates 24/7." },
  { question: "Which vehicles are available for this route?", answer: "We offer sedan cars, SUVs like Ertiga and Innova, Innova Crysta, and Tempo Travellers." },
  { question: "Can I book a one-way cab?", answer: "Yes, we provide both one-way and round-trip cab services." },
  { question: "Are vehicles air-conditioned?", answer: "Yes, all vehicles are fully air-conditioned for comfortable travel." },
  { question: "Do you provide doorstep pickup?", answer: "Yes, we offer pickup from home, hotel, and airport anywhere in Mumbai." },
  { question: "Is advance booking required?", answer: "Advance booking is recommended, especially during weekends and festive seasons." },
  { question: "Do you provide same-day return for Bhimashankar?", answer: "Yes, we offer same-day return packages for Bhimashankar darshan." },
  { question: "Are vehicles sanitized regularly?", answer: "Yes, all vehicles are cleaned and sanitized regularly for passenger safety." }
];

const testimonials = [
  {
    id: 1,
    name: "Mr. Santosh Jadhav",
    feedback: "The Mumbai to Bhimashankar cab journey with Royal Route Cabs was very smooth and comfortable. The hill drive was handled safely and professionally by the driver.",
    rating: 5
  },
  {
    id: 2,
    name: "Mrs. Radhika Deshmukh",
    feedback: "Excellent experience traveling from Mumbai to Bhimashankar. The cab was clean, the ride was safe, and the entire trip felt well-managed and peaceful.",
    rating: 5
  }
];
























  const Images = [
    { place: "/images/keyword/1.jpg", text: "Mumbai Outstation Cabs", link: "Mumbai-Outstation-Cabs" },
    { place: "/images/keyword/2.jpg", text: "Mumbai to Mahabaleshwar Cab", link: "Mumbai-to-Mahabaleshwar-Cab" },
    { place: "/images/keyword/3.jpg", text: "Mumbai to Goa Cabs", link: "Mumbai-to-Goa-Cabs" },
    { place: "/images/keyword/4.jpg", text: "Mumbai to Shirdi Cab", link: "Mumbai-to-Shirdi-Cab" },
    { place: "/images/keyword/5.jpg", text: "Mumbai Nashik Cab", link: "Mumbai-Nashik-Cab" },
    { place: "/images/keyword/6.jpg", text: "Mumbai to Kolhapur Cab", link: "Mumbai-to-Kolhapur-Cab" },
    { place: "/images/keyword/7.jpg", text: "Mumbai to Pune Cab", link: "Mumbai-to-Pune-Cab" },
    { place: "/images/keyword/8.jpg", text: "Mumbai to Aurangabad Cab", link: "Mumbai-to-Aurangabad-Cab" },
    { place: "/images/keyword/9.jpg", text: "Mumbai to Bhimashankar Cab", link: "Mumbai-to-Bhimashankar-Cab" },
    { place: "/images/keyword/10.jpg", text: "Mumbai to Ashtavinayak Cab Service", link: "Mumbai-to-Ashtavinayak-Cab-Service" },
    { place: "/images/keyword/11.jpg", text: "Mumbai to 5 Jyotirlinga cab", link: "Mumbai-to-5-Jyotirlinga-Cab" },
    { place: "/images/keyword/12.jpg", text: "Mumbai to Lonavala Cab", link: "Mumbai-to-Lonavala-Cab" },
    { place: "/images/keyword/13.jpg", text: "Mumbai to Konkan Darshan Cab Booking", link: "Mumbai-to-Konkan-Darshan-Cab-Booking" },
    { place: "/images/keyword/14.jpg", text: "Mumbai to Alibaug Cab", link: "Mumbai-to-Alibaug-Cab" },
    { place: "/images/keyword/15.jpg", text: "Mumbai to Ahmednagar Cab", link: "Mumbai-to-Ahmednagar-Cab" },
    { place: "/images/keyword/16.jpg", text: "Mumbai to Matheran cab", link: "Mumbai-to-Matheran-Cab" },
    { place: "/images/keyword/17.jpg", text: "Mumbai to Jalgaon Cab Booking / Dhule", link: "Mumbai-to-Jalgaon-Cab-Booking-Dhule" },
    { place: "/images/keyword/18.jpg", text: "Mumbai to Lavasa Cab", link: "Mumbai-to-Lavasa-Cab" },
    { place: "/images/keyword/19.jpg", text: "Mumbai to Panchgani Cab", link: "Mumbai-to-Panchgani-Cab" },
    { place: "/images/keyword/20.jpg", text: "Mumbai to Khandala Taxi Fare", link: "Mumbai-to-Khandala-Taxi-Fare" },
    { place: "/images/keyword/21.jpg", text: "Mumbai to Surat Cab", link: "Mumbai-to-Surat-Cab" },
    { place: "/images/keyword/22.jpg", text: "Mumbai to Ahmedabad Cab", link: "Mumbai-to-Ahmedabad-Cab" },
    { place: "/images/keyword/23.jpg", text: "Mumbai to Narmada Parikrama Cab Booking", link: "Mumbai-to-Narmada-Parikrama-Cab-Booking" },
    { place: "/images/keyword/24.jpg", text: "Mumbai to Baroda Cabs", link: "Mumbai-to-Baroda-Cabs" },
    { place: "/images/keyword/25.jpg", text: "Mumbai to Daman taxi", link: "Mumbai-to-Daman-Taxi" },
    { place: "/images/keyword/26.jpg", text: "Mumbai to Vapi cab", link: "Mumbai-to-Vapi-Cab" },
    { place: "/images/keyword/27.jpg", text: "Mumbai to Bangalore cab", link: "Mumbai-to-Bangalore-Cab" }
  ];







const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Mumbai to Bhimashankar Cab",
  "image": "https://www.royalroutecabs.com/assets/images/mumbai-to-bhimashankar-cab.jpg", // replace if needed
  "description": "Book Mumbai to Bhimashankar cab with Royal Route Cabs for a safe and comfortable journey. Choose from sedan, SUV, Innova, and luxury cars for one-way and round-trip travel. 24x7 reliable taxi service with experienced drivers.",
  "brand": {
    "@type": "Brand",
    "name": "Royal Route Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "ratingValue": "4.7",
    "ratingCount": "3200",
    "bestRating": "5",
    "worstRating": "1"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "2500", // adjust if needed
    "availability": "https://schema.org/InStock",
    "url": "https://www.royalroutecabs.com/mumbai-to-bhimashankar-cab"
  }
};







  return (
    <div>
<Helmet>
  <title>Mumbai to Bhimashankar Cab | Call:- +91 9529877342 | Best Outstation Cab Service</title>

  <meta
    name="description"
    content="Book Mumbai to Bhimashankar cab at best price with Royal Route Cabs. One-way & round-trip taxi service with sedan, SUV, Innova & luxury cars. Safe, reliable & 24x7 available."
  />

  <meta
    name="keywords"
    content="mumbai to bhimashankar cab, mumbai to bhimashankar taxi, mumbai to bhimashankar cab service, mumbai to bhimashankar taxi service, cab from mumbai to bhimashankar, taxi from mumbai to bhimashankar, mumbai to bhimashankar cab booking, mumbai to bhimashankar taxi booking online, mumbai to bhimashankar cab price, mumbai to bhimashankar taxi fare, mumbai to bhimashankar one way cab, mumbai to bhimashankar round trip taxi, mumbai to bhimashankar innova cab, mumbai to bhimashankar ertiga cab, mumbai to bhimashankar sedan cab, mumbai to bhimashankar suv taxi, cheap mumbai to bhimashankar cab, best mumbai to bhimashankar taxi service"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>

      <div
        className="breadcrumb-wrapper section-padding bg-cover"
        style={{ backgroundImage: "url('/img/breadcrumb-bg.jpeg')" }}
      >
        <div className="container-fluid">
          <div className="page-heading">
            <h1 className="text-center">{cardData.keyword}</h1>
          </div>
        </div>
      </div>














      <section>
        <div className="container-fluid" >
          <div className="row container-fluid">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/9.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >Royal Route Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                {/* <p className="sectionLead">{cardData.top}</p> */}

                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard borderr" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>

                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>


              <div className="services-section">
                {cardData.services.map((service, index) => (
                  <div key={index} className="service-row">
                    {/* <div className="service-icon">
                      🚗
                    </div> */}
                    <div>
                      <h4 className="service-title">{service.name}</h4>
                      <p className="service-desc">{service.description}</p>
                    </div>
                  </div>
                ))}
              </div>


          <div className="keyword-grid">
  {cardData.tableData.flat().map((keyword, index) => (
    <div key={index} className="keyword-item">
      <span className="keyword-bullet">-</span>
      {keyword}
    </div>
  ))}
</div>
              {/* <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable /> */}

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title text-white">
                  Why Choose <span>Royal Route Cab</span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Royal Route Cab </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title=""
                          subtitle=""
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase keyword={cardData.keyword} />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+919529877342" className="pc-call">+91 9529877342</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/919529877342"
                        target="_blank"
                        rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp"></i> WhatsApp
                      </a>
                      <a href="tel:+919529877342" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@royalroutecabs.com" className="pc-email">
                      booking@royalroutecabs.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-geo-alt-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Royal Route Cab</strong><br />
                      Shop Number 57, Prabhat Colony Opp. Panbai International School Vimladevi Road,Santacruz(E) Mumbai Maharashtra-400055.


                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Mumbaitobhimashankarcab;